import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, tap } from "rxjs";
import { CommonDropDown, SingleCommonDropDown } from "../common/types/dropdown.type";
import { HttpClient, HttpParams } from "@angular/common/http";
import { BaseRespone } from "../models/common.response";
import { environment } from "src/environments/environment";
import { ExternalEntitiesType } from "../common/enums/external-entities-type";
import { CategoryType } from "../common/enums/category-type";


@Injectable({ providedIn: 'root' })
export class LookupService {

    private _clinicalcategories: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _clinicalsubcategories: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _billcharges: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _patients: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _doctors: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _appointmenttypes: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _paymenttypes: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _drugtypes: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _drugcompanies: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _genericcontents: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _billnumbers: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _speciality: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _education: BehaviorSubject<SingleCommonDropDown[]> = new BehaviorSubject<SingleCommonDropDown[]>([]);
    private _sensitivity: BehaviorSubject<SingleCommonDropDown[]> = new BehaviorSubject<SingleCommonDropDown[]>([]);
    private _allergy: BehaviorSubject<SingleCommonDropDown[]> = new BehaviorSubject<SingleCommonDropDown[]>([]);
    private _wards: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _roomtypes: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _roomNumber: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _bedNumber: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _externalEntities: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _natureOfTreatments: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _assistantDoctors: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _anesthetists: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _mediclaims: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    private _drugDetails: BehaviorSubject<CommonDropDown[]> = new BehaviorSubject<CommonDropDown[]>([]);
    constructor(
        private _httpclient: HttpClient,
    ) { }

    get clinicalcategories$(): Observable<CommonDropDown[]> {
        return this._clinicalcategories.asObservable();
    }

    get clinicalsubcategories$(): Observable<CommonDropDown[]> {
        return this._clinicalsubcategories.asObservable();
    }

    get billcharges$(): Observable<CommonDropDown[]> {
        return this._billcharges.asObservable();
    }

    get doctors$(): Observable<CommonDropDown[]> {
        return this._doctors.asObservable();
    }

    get patients$(): Observable<CommonDropDown[]> {
        return this._patients.asObservable();
    }

    get appointmenttype$(): Observable<CommonDropDown[]> {
        return this._appointmenttypes.asObservable();
    }

    get paymenttypes$(): Observable<CommonDropDown[]> {
        return this._paymenttypes.asObservable();
    }

    get drugtypes$(): Observable<CommonDropDown[]> {
        return this._drugtypes.asObservable();
    }

    get drugcompanies$(): Observable<CommonDropDown[]> {
        return this._drugcompanies.asObservable();
    }

    get genericcontents$(): Observable<CommonDropDown[]> {
        return this._genericcontents.asObservable();
    }

    get billnumbers$(): Observable<CommonDropDown[]> {
        return this._billnumbers.asObservable();
    }

    get speciality$(): Observable<CommonDropDown[]> {
        return this._speciality.asObservable();
    }

    get education$(): Observable<SingleCommonDropDown[]> {
        return this._education.asObservable();
    }

    get sensitivity$(): Observable<SingleCommonDropDown[]> {
        return this._sensitivity.asObservable();
    }

    get allergy$(): Observable<SingleCommonDropDown[]> {
        return this._allergy.asObservable();
    }

    get wards$(): Observable<CommonDropDown[]> {
        return this._wards.asObservable();
    }

    get roomtypes$(): Observable<CommonDropDown[]> {
        return this._roomtypes.asObservable();
    }

    get roomNumber$(): Observable<CommonDropDown[]> {
        return this._roomNumber.asObservable();
    }

    get bedNumber$(): Observable<CommonDropDown[]> {
        return this._bedNumber.asObservable();
    }

    get externalEntities$(): Observable<CommonDropDown[]> {
        return this._externalEntities.asObservable();
    }

    get natureOfTreatments$(): Observable<CommonDropDown[]> {
        return this._natureOfTreatments.asObservable();
    }

    get assistantDoctors$(): Observable<CommonDropDown[]> {
        return this._assistantDoctors.asObservable();
    }

    get anesthetists$(): Observable<CommonDropDown[]> {
        return this._anesthetists.asObservable();
    }

    get mediClaims$(): Observable<CommonDropDown[]> {
        return this._mediclaims.asObservable();
    }

    getHospital(): Observable<BaseRespone<CommonDropDown[]>> {
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/Gethospital`).pipe(
            tap((response) => {
                return response;
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    getDoctors(date?: Date): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (date) {
            params = params.set('date', date.toISOString());
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetDoctor`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._doctors.next(response);
            })
        );
    }

    getAsstDoctors(search?: string): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetAsstDoctor`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._assistantDoctors.next(response);
            })
        );
    }

    getCategory(search?: string): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetClinicalCategory`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._clinicalcategories.next(response);
            })
        );

    }

    getCategoryByType(categoryTypeId: CategoryType): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        params = params.set('CategoryTypeId', categoryTypeId.toString());

        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetClinicalCategory`, { params }).pipe(
            map(response => {
                return response.result
            }),
            catchError((error) => {
                console.error('Error fetching categories by type:', error);
                throw error;
            })
        );
    }

    getSubCategory(categoryId: number, search?: string): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        params = params.set('CategoryId', categoryId.toString());
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetClinicalSubCategory`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._clinicalsubcategories.next(response);
            })
        );
    }

    getPatient(search?: string): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetPatient`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._patients.next(response);
            })
        );
    }

    getBillCharge(): Observable<CommonDropDown[]> {
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetBillCharge`).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._billcharges.next(response);
            })
        );
    }

    getPaymentTypeLookup(search?: string): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetPaymentType`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._paymenttypes.next(response);
            })
        );

    }

    getAppointmentTypeLookup(): Observable<CommonDropDown[]> {
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetAppointmentType`).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._appointmenttypes.next(response);
            })
        );
    }

    getSpeciality(): Observable<CommonDropDown[]> {
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetSpeciality`).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._speciality.next(response);
            })
        );

    }

    getEducation(search?: string): Observable<SingleCommonDropDown[]> {
        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseURl}/Lookup/GetEducation`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._education.next(response);
            })
        );
    }

    getAllergy(search?: string): Observable<SingleCommonDropDown[]> {

        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseURl}/Lookup/GetAllergy`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._allergy.next(response);
            })
        );

    }

    getSensitivity(search?: string): Observable<SingleCommonDropDown[]> {

        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseURl}/Lookup/GetSensitivity`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._sensitivity.next(response);
            })
        );

    }

    getDrugType(search?: string): Observable<CommonDropDown[]> {

        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetDrugType`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._drugtypes.next(response);
            })
        );

    }

    getDrugCompany(search?: string): Observable<CommonDropDown[]> {

        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetDrugCompany`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._drugcompanies.next(response);
            })
        );

    }

    getGenericContent(): Observable<CommonDropDown[]> {
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetGenericContent`).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._genericcontents.next(response);
            })
        );
    }

    getBillNumber(search?: string): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetBillNumber`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._billnumbers.next(response);
            })
        );

    }

    getWards(search?: string, checkAvailability?: boolean, includeIds?: number[]): Observable<CommonDropDown[]> {
        let params = new HttpParams();

        if (search) {
            params = params.set('value', search);
        }

        if (checkAvailability) {
            params = params.set('CheckAvailability', 'true');
        }

        if (includeIds && includeIds.length > 0) {
            params = params.set('includeIds', includeIds.join(','));
        }

        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetWard`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._wards.next(response);
            })
        );
    }

    getRoomTypes(search?: string, wardId?: number): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (wardId) {
            params = params.set('WardId', wardId.toString());
        }
        if (search) {
            params = params.set('Value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetRoomType`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._roomtypes.next(response);
            })
        );
    }

    getRoomNumber(search?: string, wardId?: number, checkAvailability?: boolean, includeIds?: number[]): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (wardId) {
            params = params.set('WardId', wardId.toString());
        }
        if (search) {
            params = params.set('Value', search);
        }
        if (checkAvailability) {
            params = params.set('CheckAvailability', 'true');
        }
        if (includeIds && includeIds.length > 0) {
            params = params.set('includeIds', includeIds.join(','));
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetRoomNumber`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._roomNumber.next(response);
            })
        );
    }

    getBedNumbers(roomId?: number, search?: string, includeIds?: number[]): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (roomId) {
            params = params.set('RoomId', roomId.toString());
        }
        if (search) {
            params = params.set('Value', search);
        }
        if (includeIds && includeIds.length > 0) {
            params = params.set('includeIds', includeIds.join(','));
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetBedNumber`, { params }).pipe(
            map(response => response.result),
            tap((response) => {
                this._bedNumber.next(response);
            })
        );
    }

    getPrescriptionTemplateName(params: { doctorId: number; keyword?: string }): Observable<BaseRespone<CommonDropDown[]>> {

        let httpParams = new HttpParams().set('doctorId', params.doctorId);

        if (params.keyword) {
            httpParams = httpParams.set('Value', params.keyword);
        }

        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetPrescriptionTemplate`, { params: httpParams });
    }

    getExternalEntities(entityType?: ExternalEntitiesType): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (entityType !== undefined) {
            params = params.set('ExternalEntityType', entityType.toString());
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetExternalEntities`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._externalEntities.next(response);
            })
        );
    }

    getNatureOfTreatment(search?: string): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetNatureOfTreatment`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._natureOfTreatments.next(response);
            })
        );
    }

    getMediclaim(): Observable<CommonDropDown[]> {
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetMediclaimPlan`).pipe(
            map(response => response.result),
            tap(result => {
                this._mediclaims.next(result);
            })
        );
    }

    getDrugDetails(search?: string): Observable<CommonDropDown[]> {
        let params = new HttpParams();
        if (search) {
            params = params.set('value', search);
        }
        return this._httpclient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseURl}/Lookup/GetDrugDetail`, { params }).pipe(
            map(response => {
                return response.result
            }),
            tap((response) => {
                this._drugDetails.next(response);
            })
        );
    }

}
